// Ограничение степперов категорий в мобильных Table4/5DetailsLayout.
export const canUpdateCategoryShare = (row, field, value, fields) => {
  const raw = String(value ?? '').trim();
  if (raw && !/^\d+$/.test(raw)) return false;
  const number = Number(raw);
  const otherTotal = fields.filter(key => key !== field)
    .reduce((sum, key) => sum + (Number(row[key]) || 0), 0);
  return number >= 0 && number <= Math.min(100, Math.max(0, 100 - otherTotal));
};
